import { gql } from '@apollo/client'

export const INTEGRATION_REGISTRATIONS_QUERY = gql`
  query FindIntegrationRegistrations($aircraftsOrgSlug: String!) {
    integrationRegistrations {
      id
      enabled
      validated
      aircraft {
        id
        tailNumber
        name
        orgSlug
      }
      integration {
        id
        name
        displayName
      }
      IntegrationRegistrationOperation {
        id
        enabled
        operation {
          id
          operationName
          description
        }
      }
    }
    aircrafts(orgSlug: $aircraftsOrgSlug) {
      id
      tailNumber
      name
      orgSlug
    }
    integrations {
      id
      name
      displayName
      IntegrationOperation {
        id
        operationName
        description
      }
    }
  }
`
